<script>
import DelfosNotificationsAPI from 'dashboard/api/delfosNotifications';
import { getDelfosNotificationPreferences } from 'dashboard/helper/pushHelper';

export default {
  data() {
    return {
      items: [],
      messageCount: 0,
      conversationCount: 0,
      isOpen: false,
      isLoading: false,
      refreshTimer: null,
      copy: {
        openPending: 'Abrir mensagens pendentes',
        pending: 'pendentes',
        title: 'Mensagens pendentes',
        close: 'Fechar',
        loading: 'Atualizando...',
        allHandled: 'Todas as mensagens ja foram atendidas.',
      },
    };
  },
  computed: {
    accountId() {
      return this.$store.getters.getCurrentAccountId;
    },
    isEnabled() {
      return getDelfosNotificationPreferences().enabled;
    },
    shouldShowLauncher() {
      return this.isEnabled && this.conversationCount > 0;
    },
    pendingSummary() {
      return `${this.messageCount} mensagens em ${this.conversationCount} conversas`;
    },
  },
  watch: {
    '$route.query.delfos_pending': {
      handler(value) {
        if (value === '1') this.openPending();
      },
      immediate: true,
    },
    accountId() {
      this.refresh();
    },
  },
  mounted() {
    window.addEventListener(
      'delfos:notifications-updated',
      this.handleNotificationUpdate
    );
    this.refreshTimer = window.setInterval(() => this.refresh(), 60000);
    window.setTimeout(() => this.refresh(), 1500);
  },
  beforeUnmount() {
    window.removeEventListener(
      'delfos:notifications-updated',
      this.handleNotificationUpdate
    );
    window.clearInterval(this.refreshTimer);
  },
  methods: {
    handleNotificationUpdate(event) {
      const { kind, payload } = event.detail || {};
      if (kind === 'pending' && payload) {
        this.applyPayload(payload);
        return;
      }
      this.refresh();
    },
    async refresh() {
      if (!this.accountId || !this.isEnabled) return;
      try {
        const { data } = await DelfosNotificationsAPI.getPending(
          this.accountId
        );
        this.applyPayload(data);
      } catch (error) {
        this.applyPayload({
          items: [],
          message_count: 0,
          conversation_count: 0,
        });
      }
    },
    applyPayload(payload) {
      this.items = payload.items || [];
      this.messageCount = payload.message_count || 0;
      this.conversationCount = payload.conversation_count || 0;
      if (this.isOpen && this.conversationCount === 0) {
        this.isOpen = false;
      }
    },
    async openPending() {
      this.isOpen = true;
      this.isLoading = true;
      await this.refresh();
      this.isLoading = false;
      if (this.conversationCount === 1) {
        this.openConversation(this.items[0]);
      }
    },
    close() {
      this.isOpen = false;
      if (this.$route.query.delfos_pending) {
        const query = { ...this.$route.query };
        delete query.delfos_pending;
        this.$router.replace({ query });
      }
    },
    openConversation(item) {
      this.isOpen = false;
      window.location.assign(item.url);
    },
  },
};
</script>

<template>
  <div v-if="isEnabled" class="delfos-notification-center">
    <button
      v-if="shouldShowLauncher"
      type="button"
      class="fixed top-16 right-5 z-[70] flex items-center gap-2 h-10 px-3 text-sm font-medium text-white bg-n-teal-10 hover:bg-n-teal-11 border-0 rounded-lg shadow-lg"
      :title="copy.openPending"
      @click="openPending"
    >
      <fluent-icon icon="alert" size="18" />
      <span>{{ messageCount }} {{ copy.pending }}</span>
    </button>

    <div
      v-if="isOpen"
      class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-n-alpha-3"
      @click.self="close"
    >
      <section
        class="flex flex-col w-full max-w-2xl max-h-[82vh] overflow-hidden bg-n-solid-2 border border-n-weak rounded-lg shadow-xl"
        role="dialog"
        aria-modal="true"
        :aria-label="copy.title"
      >
        <header
          class="flex items-center justify-between gap-3 px-5 py-4 border-b border-n-weak"
        >
          <div class="min-w-0">
            <h2 class="text-heading-2 text-n-slate-12">{{ copy.title }}</h2>
            <p class="text-body-small text-n-slate-10">
              {{ pendingSummary }}
            </p>
          </div>
          <button
            type="button"
            class="flex items-center justify-center flex-shrink-0 size-9 text-n-slate-11 hover:text-n-slate-12 hover:bg-n-alpha-2 rounded-lg"
            :title="copy.close"
            @click="close"
          >
            <fluent-icon icon="dismiss" size="20" />
          </button>
        </header>

        <div v-if="isLoading" class="p-6 text-center text-n-slate-10">
          {{ copy.loading }}
        </div>
        <div
          v-else-if="items.length"
          class="flex flex-col overflow-y-auto divide-y divide-n-weak"
        >
          <button
            v-for="item in items"
            :key="item.id"
            type="button"
            class="grid grid-cols-[48px_minmax(0,1fr)_auto] items-center gap-3 w-full px-5 py-4 text-left hover:bg-n-alpha-1"
            @click="openConversation(item)"
          >
            <img
              :src="item.thumbnail"
              :alt="item.contact_name"
              class="size-12 object-cover rounded-lg bg-n-alpha-2"
            />
            <span class="min-w-0">
              <strong class="block truncate text-body-main text-n-slate-12">
                {{ item.contact_name }}
              </strong>
              <span class="block truncate text-body-small text-n-slate-10">
                {{ item.preview }}
              </span>
              <span class="block truncate text-label-small text-n-slate-9">
                {{ item.inbox_name }}
              </span>
            </span>
            <span
              class="flex items-center justify-center min-w-7 h-7 px-2 text-xs font-medium text-white bg-n-teal-10 rounded-full"
            >
              {{ item.message_count }}
            </span>
          </button>
        </div>
        <div v-else class="p-8 text-center text-n-slate-10">
          {{ copy.allHandled }}
        </div>
      </section>
    </div>
  </div>
</template>
